import React, { useState } from 'react';
import moment from 'moment';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CustomSelect from '../../../common/formElements/CustomSelect';
import CustomInputWithIconNoFormGroup from '../../../common/ui/CustomInputWithIconNoFormGroup';
import showAlert from '../../../common/utils/alert';
import { awsRegion } from '../../../common/utils/api_utils';
import CypherTest from './CypherTest';

export const EncryptionSettingForm = ({
  projectId,
  seoName,
  encryption,
  environments,
  updateEncryptionSetting,
  updateEncAwsSetting,
  resetEncryptionSetting,
  cypherText,
  version,
  envType,
  isReadOnly,
}) => {
  let dataKey,
    accKey,
    secKey,
    reg = '';
  let keyId = '';

  if (encryption) {
    const { awsConfig } = encryption;
    dataKey = encryption.dataKey;
    if (awsConfig) {
      const { accessKeyId, secretAccessKey, region, arn } = awsConfig;
      if (accessKeyId) accKey = accessKeyId;
      if (secretAccessKey) secKey = secretAccessKey;
      if (region) reg = region;
      if (arn) keyId = arn;
    }
  }
  const [encryptionType, setEncryptionType] = useState('KMS');
  const [key, setKey] = useState(dataKey);
  const [accessKeyId, setAccessKeyId] = useState(accKey);
  const [secretAccessKey, setSecretAccessKey] = useState(secKey);
  const [region, setRegion] = useState(reg);
  const [arn, setArn] = useState(keyId);
  const [toggle, setToggle] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const preConfirm = () =>
      updateEncryptionSetting({
        envType,
        projectId,
        version,
        encryptionType,
        accessKeyId,
        secretAccessKey,
        region,
        keyId: arn,
      })
        .then(({ data }) => {
          if (data.success === false) {
            console.log('data.message', data.message);
          } else {
            const encryptions = data.encryptions;
            console.log('encryptions', encryptions);
            const encryption = encryptions.find((enc) => enc.envType === envType);
            const {
              // encryptionType, We don't have encryption type in encryption
              dataKey,
              awsConfig: { accessKeyId, region, secretAccessKey, keyId },
            } = encryption;
            setAccessKeyId(accessKeyId);
            setSecretAccessKey(secretAccessKey);
            setRegion(region);
            setArn(keyId);
            // setEncryptionType(encryptionType);
            setKey(dataKey);
            download(dataKey);
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    showAlert(
      "By Changing the encryption settings, you won't be able decrypt old data ",
      preConfirm,
      'Yes, Update it!',
    );
  };

  const handleDirectSubmit = (e) => {
    e.preventDefault();
    const preConfirm = () =>
      updateEncAwsSetting({
        envType,
        projectId,
        version,
        encryptionType,
        accessKeyId,
        secretAccessKey,
        region,
      })
        .then(({ data }) => {
          if (data.success === false) {
            console.log('data.message', data.message);
          } else {
            const encryptions = data.encryptions;
            const encryption = encryptions.find((enc) => enc.envType === envType);
            const {
              encryptionType,
              awsConfig: { accessKeyId, region, secretAccessKey },
            } = encryption;
            setAccessKeyId(accessKeyId);
            setSecretAccessKey(secretAccessKey);
            setRegion(region);
            setEncryptionType(encryptionType);
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    showAlert(
      'Please make sure, this IAM has permission to manage KMS.',
      preConfirm,
      'Yes, Update it!',
    );
  };
  const handleReset = (e) => {
    e.preventDefault();
    const preConfirm = () =>
      resetEncryptionSetting({
        envType,
        encryptionType,
        projectId,
        version,
      })
        .then(({ data }) => {
          if (data.success === false) {
            console.log('data.message', data.message);
          } else {
            setAccessKeyId('');
            setSecretAccessKey('');
            setRegion('');
            setArn('');
            setKey('');
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    showAlert(
      "Once encryption setting is reset, you won't be able to recover it and decrypt old data",
      preConfirm,
      'Yes, reset it!',
    );
  };

  const download = (dataKey) => {
    if (!dataKey) {
      dataKey = key;
    }
    const blob = new Blob([dataKey], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const dateStr = moment().format('YYYY_MM_DD_h_mm');
    const name = `${seoName}_${dateStr}.txt`;
    link.download = name;
    link.href = url;
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const handleDownload = (e) => {
    e.preventDefault();

    showAlert(
      "Please don't share this to anyone and store it at safe place.",
      download,
      'Download',
    );
  };

  const showCommonSetting = () => {
    return (
      <>
        <CustomInputWithIconNoFormGroup
          title="AWS Access Key ID"
          icon="text"
          required={true}
          style="py-2"
        >
          <input
            type="text"
            name="accessKeyId"
            className="form-control"
            placeholder="Enter AWS Access Key ID"
            value={accessKeyId}
            onChange={(e) => setAccessKeyId(e.target.value)}
          />
        </CustomInputWithIconNoFormGroup>
        <CustomInputWithIconNoFormGroup
          title="AWS Secret Access Key"
          icon="password"
          required={true}
          style="py-2"
        >
          <input
            type="password"
            name="secretAccessKey"
            className="form-control"
            placeholder="Enter AWS Secret Access Key"
            value={secretAccessKey}
            onChange={(e) => setSecretAccessKey(e.target.value)}
          />
        </CustomInputWithIconNoFormGroup>
        <CustomInputWithIconNoFormGroup title="AWS Region" icon="text" required={true} style="py-2">
          <CustomSelect
            name="region"
            isMulti={false}
            options={awsRegion}
            value={region}
            onChange={(name, value) => setRegion(value)}
            placeholder="Select AWS Region"
          />
        </CustomInputWithIconNoFormGroup>
      </>
    );
  };

  const showExtraSetting = () => {
    if (key) {
      return (
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div className="form-group">{showCommonSetting()}</div>
          </div>
          <div className="col-md-12 col-lg-12 mt-2 text-right">
            <button
              className="btn btn-theme-submit btn-md"
              onClick={isReadOnly ? undefined : handleDirectSubmit}
              disabled={isReadOnly}
              title={isReadOnly && 'Read-Only Mode'}
            >
              <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Update Setting&nbsp;
            </button>
          </div>
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div className="form-group">
              {key && (
                <CustomInputWithIconNoFormGroup
                  title="KMS Data Key"
                  icon="text"
                  required={true}
                  disabled={true}
                  style="py-2"
                >
                  <input
                    type="text"
                    name="key"
                    className="form-control"
                    disabled={true}
                    value={key}
                  />
                </CustomInputWithIconNoFormGroup>
              )}
            </div>
          </div>
          <div className="col-md-12 col-lg-12 mt-2 text-right">
            <button
              className="btn btn-theme-delete btn-md"
              onClick={isReadOnly ? undefined : handleReset}
              disabled={isReadOnly}
              title={isReadOnly && 'Read-Only Mode'}
            >
              <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Reset Setting&nbsp;
            </button>
            <button
              className="btn btn-primary btn-md"
              onClick={isReadOnly ? undefined : handleDownload}
              disabled={isReadOnly}
              title={isReadOnly && 'Read-Only Mode'}
            >
              <i className={`wb ${drapcodeIcon('install')}`}></i>&nbsp;Download Private Key&nbsp;
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div className="form-group">
              {showCommonSetting()}
              <CustomInputWithIconNoFormGroup
                title="KMS ARN"
                icon="text"
                required={true}
                style="py-2"
              >
                <input
                  type="text"
                  name="arn"
                  className="form-control"
                  placeholder="Enter KMS ARN"
                  value={arn}
                  onChange={(e) => setArn(e.target.value)}
                />
              </CustomInputWithIconNoFormGroup>
              {key && (
                <CustomInputWithIconNoFormGroup
                  title="KMS Data Key"
                  icon="text"
                  required={true}
                  disabled={true}
                  style="py-2"
                >
                  <input
                    type="text"
                    name="key"
                    className="form-control"
                    disabled={true}
                    value={key}
                  />
                </CustomInputWithIconNoFormGroup>
              )}
            </div>
          </div>
          <div className="col-md-12 col-lg-12 mt-2 text-right">
            <button
              className="btn btn-theme-submit btn-md"
              onClick={isReadOnly ? undefined : handleSubmit}
              disabled={isReadOnly}
              title={isReadOnly && 'Read-Only Mode'}
            >
              <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Validate & Update&nbsp;
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12">
          <form className="form-horizontal">{showExtraSetting()}</form>
        </div>
        <hr />
        <div className="col-md-12 col-lg-12 col-sm-12 border mt-3">
          <h3 className="text-center">Encryption/Decryption Test</h3>
          <CypherTest
            envType={envType}
            projectId={projectId}
            version={version}
            cypherText={cypherText}
          />
        </div>
      </div>
    </div>
  );
};
